import dayjs from 'dayjs';

const businessUnitId = document.getElementById('tpbu-id').value; //'4dd3bfa700006400050fb6c0';
const apiKey = document.getElementById('tp-api').value; //'vSHu9w4r6DYCmwN3t7lSl2sqmsrNDvbA';

const useTrustPilot = businessUnitId.length && apiKey.length ? true : false;

const basedOnLabel = document.getElementById('based_on_label').value;
const averageLabel = document.getElementById('average_label').value;
const microdataEl = document.querySelector('#product-microdata');
const newLinesRx = /\r?\n|\r/g; //To remove new lines which break the JSON parsing - API does not do this (ridiculously)

let microdata;

if (microdataEl) {
	microdata = JSON.parse(microdataEl.innerHTML);
}

function microdataAggregateReviews(averageRating, count) {
	return  JSON.parse(`{
    "@type": "AggregateRating",
    "ratingValue": "${averageRating}",
    "reviewCount": "${count}"
  }`)
}

function microdataReviews(reviews) {
	return reviews.map((review) => {
		const content = review.content.replaceAll(newLinesRx, ' '); // Check the review content for line breaks and remove them (swap for a space)
		
		return JSON.parse(`{
      "@type": "Review",
      "author": {
				"@type":"Person", 
				"name": "${review.consumer.displayName}"
			},
      "datePublished": "${review.createdAt}",
      "reviewBody": "${content}",
      "reviewRating": {
        "@type": "Rating",
        "bestRating": "5",
        "ratingValue": "${review.stars}",
        "worstRating": "1"
      }
    }`)
	});
}

function starTemplate(rating, count, className) {
	if (!count) {
		count = 0;
	}

	return `<div class="icon stars stars--${rating}-star ${className ? className : 'icon--s'}">
	<svg viewbox="0 0 59 10" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon__svg">
		<title>${averageLabel}</title>
		<defs><linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
		<stop offset="0" stop-color="#FF9A00"></stop>
		<stop offset="50%" stop-color="#FF9A00"></stop>
		<stop offset="50%" stop-color="#FF9A00" stop-opacity="0.2"></stop>
		<stop offset="100%" stop-color="#FF9A00" stop-opacity="0.2"></stop>
	</linearGradient><path id="a" d="M0 0h10.423v9.968H0z"/><path id="c" d="M0 0h10.423v9.968H0z"/><path id="e" d="M0 0h10.423v9.968H0z"/><path id="g" d="M0 0h10.423v9.968H0z"/><path id="i" d="M0 0h10.423v9.968H0z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(.5)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path class="star star-1" d="M5.722.317l1.17 2.37a.57.57 0 00.428.311l2.615.38a.57.57 0 01.315.97L8.358 6.194a.569.569 0 00-.164.504l.447 2.605a.57.57 0 01-.826.6l-2.339-1.23a.57.57 0 00-.53 0l-2.339 1.23a.57.57 0 01-.825-.6l.446-2.605a.569.569 0 00-.163-.504L.173 4.35a.57.57 0 01.315-.97l2.615-.38a.57.57 0 00.428-.312l1.17-2.37a.569.569 0 011.02 0" fill="currentColor" mask="url(#b)"/></g><g transform="translate(12.41)"><mask id="d" fill="#fff"><use xlink:href="#c"/></mask><path class="star star-2" d="M5.722.317l1.17 2.37a.57.57 0 00.428.311l2.615.38a.57.57 0 01.315.97L8.358 6.194a.569.569 0 00-.164.504l.447 2.605a.57.57 0 01-.826.6l-2.339-1.23a.57.57 0 00-.53 0l-2.339 1.23a.57.57 0 01-.825-.6l.446-2.605a.569.569 0 00-.163-.504L.173 4.35a.57.57 0 01.315-.97l2.615-.38a.57.57 0 00.428-.312l1.17-2.37a.569.569 0 011.02 0" fill="currentColor" mask="url(#d)"/></g><g transform="translate(24.318)"><mask id="f" fill="#fff"><use xlink:href="#e"/></mask><path class="star star-3" d="M5.722.317l1.17 2.37a.57.57 0 00.428.311l2.615.38a.57.57 0 01.315.97L8.358 6.194a.569.569 0 00-.164.504l.447 2.605a.57.57 0 01-.826.6l-2.339-1.23a.57.57 0 00-.53 0l-2.339 1.23a.57.57 0 01-.825-.6l.446-2.605a.569.569 0 00-.163-.504L.173 4.35a.57.57 0 01.315-.97l2.615-.38a.57.57 0 00.428-.312l1.17-2.37a.569.569 0 011.02 0" fill="currentColor" mask="url(#f)"/></g><g transform="translate(36.227)"><mask id="h" fill="#fff"><use xlink:href="#g"/></mask><path class="star star-4" d="M5.722.317l1.17 2.37a.57.57 0 00.428.311l2.615.38a.57.57 0 01.315.97L8.358 6.194a.569.569 0 00-.164.504l.447 2.605a.57.57 0 01-.826.6l-2.339-1.23a.57.57 0 00-.53 0l-2.339 1.23a.57.57 0 01-.825-.6l.446-2.605a.569.569 0 00-.163-.504L.173 4.35a.57.57 0 01.315-.97l2.615-.38a.57.57 0 00.428-.312l1.17-2.37a.569.569 0 011.02 0" fill="currentColor" mask="url(#h)"/></g><g transform="translate(48.136)"><mask id="j" fill="#fff"><use xlink:href="#i"/></mask><path class="star star-5" d="M5.722.317l1.17 2.37a.57.57 0 00.428.311l2.615.38a.57.57 0 01.315.97L8.358 6.194a.569.569 0 00-.164.504l.447 2.605a.57.57 0 01-.826.6l-2.339-1.23a.57.57 0 00-.53 0l-2.339 1.23a.57.57 0 01-.825-.6l.446-2.605a.569.569 0 00-.163-.504L.173 4.35a.57.57 0 01.315-.97l2.615-.38a.57.57 0 00.428-.312l1.17-2.37a.569.569 0 011.02 0" fill="currentColor" mask="url(#j)"/></g></g></svg>	
		${count ? `<span class="stars__count">${count}</span>` : ``}
	</div>`
};

function review(data) {
	return `<div class="box box--review">
	<div class="stack">
		${starTemplate(data.stars, dayjs(data.createdAt).format('D MMM YYYY'))}
		<p><span class="bold">${data.consumer.displayName} -</span> ${data.content}</p>
	</div>
</div>`
}

function roundToHalf(num) {
		
	return Math.round(num / 0.5) * 0.5;

}

export function productReviews() {
	const productSummary = document.querySelector('.js-product-review-summary');
	const reviewBlock = document.querySelector('.js-review-block');
	const reviewBlockSummary = document.querySelector('.js-review-block-summary');
	const reviewGrid = document.querySelector('.js-review-grid');
	const reviewBasedLabel = document.querySelector('.js-review-based-label');
	const loadMore = document.querySelector('.js-load-more');
	const loadMoreBtn = loadMore ? loadMore.querySelector('button') : null;
	const skuInput = document.querySelector('#sku')
	const sku = skuInput ? skuInput.value : null;
	const skus = document.querySelector('#sku-qs').value;

	if (loadMore) {

		loadMoreBtn.addEventListener('click', (e) => {
			e.preventDefault();
	
			const url = `${e.target.dataset.fetchUrl}&apikey=${apiKey}`;
	
			return getReviews(url);
	
		}, false)

	}

	const data = {
		"locale": "en-GB",
		"skus": skus.split(',')
	}

	let allData = [];

	function getReviews(url) {

		return fetch(url)
			.then(response => {
				return response.json();
			})
			.then(data => {
				if (data.links.length) {
					if (data.links[0].rel === 'next-page') {
						loadMoreBtn.setAttribute('data-fetch-url', `${data.links[0].href}`);
						loadMore.removeAttribute('hidden');
					} else {
						loadMore.setAttribute('hidden', '');
					}
				} else {
					loadMore.setAttribute('hidden', '');
				}
				return data.productReviews;
			})
			.then(reviews => {
				return reviews.map(reviewData => {
					return review(reviewData);
				}).join('');
			})
			.then(reviewsHTML => {
				return reviewGrid.insertAdjacentHTML('beforeend', reviewsHTML);
			})
	}

	function getTotalReviews(url) {
		
		return fetch(url)
			.then(response => {
				return response.json();
			})
			.then(data => {

				allData.push(data.productReviews);

				if (data.links.length) {
					if (data.links[0].rel === 'next-page') {
						return getTotalReviews(`${data.links[0].href}&apikey=${apiKey}`)
					}
				}
				return;
			})
	}

	function updateMicrodata() {
		if (document.querySelector('#microdata-ld-json')) {
			return;
		}
		var mdScript = document.createElement('script');
		mdScript.setAttribute('type', 'application/ld+json');
		mdScript.setAttribute('id', 'microdata-ld-json');
		mdScript.innerHTML = JSON.stringify(microdata);
		return document.querySelector('head').appendChild(mdScript);
	}

	function getSummary() {

		if (!useTrustPilot) {
			return updateMicrodata();
		}
		
		return fetch(`https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/batch-summaries?apikey=${apiKey}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		})
		.then(response => {
			return response.json();
		})
		.then(data => {
			if (data.summaries[0]) {

				
				const starsTotal = data.summaries.reduce((a,b) => ({starsAverage: a.starsAverage + b.starsAverage}));
				const totalReviewCount = data.summaries.reduce((a,b) => ({numberOfReviews: {total: a.numberOfReviews.total + b.numberOfReviews.total}})).numberOfReviews.total;
				
				const starsTotalAverage = starsTotal.starsAverage/data.summaries.length;
		

				productSummary.innerHTML = `<a href="#reviews" class="link link--no-border">${starTemplate(roundToHalf(starsTotalAverage).toString().replace('.', '-'), totalReviewCount)}</a>`;

				reviewBlockSummary.innerHTML = starTemplate(roundToHalf(starsTotalAverage).toString().replace('.', '-'), '', 'icon-review-summary');
				productSummary.removeAttribute('hidden');
				reviewBlock.setAttribute('id', 'reviews');
				reviewBasedLabel.innerHTML = basedOnLabel.replace('####', totalReviewCount);
				reviewBlock.removeAttribute('hidden');
				
				return {
					numberOfReviews: totalReviewCount,
					averageRating: starsTotalAverage
				};
			}

			return {}
		})
		.then(data => {
			if (data.numberOfReviews) {
				microdata.aggregateRating = microdataAggregateReviews(data.averageRating, data.numberOfReviews);
			}
			return data;
		})
		.then(()=> {
			microdata.review = microdataReviews(allData.flat());
		})
		.then(()=> {
			// if (document.querySelector('#microdata-ld-json')) {
			// 	return;
			// }
			// var mdScript = document.createElement('script');
			// mdScript.setAttribute('type', 'application/ld+json');
			// mdScript.setAttribute('id', 'microdata-ld-json');
			// mdScript.innerHTML = JSON.stringify(microdata);
			// return document.querySelector('head').appendChild(mdScript);
			return updateMicrodata();
		})
		.catch(error => {
			console.error('⚠️ Promise Rejection', error);
		});
	}

	if (productSummary) {

		getTotalReviews(`https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/reviews?apikey=${apiKey}&sku=${skus}&perPage=100`).then(() => {
			return getSummary()
		});

		getReviews(`https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/reviews?apikey=${apiKey}&sku=${skus}&perPage=9`);
		
	} else {
		updateMicrodata();
	}
}

export function cardScores() {
	
	const productCards = document.querySelectorAll('.product-card');

	if (productCards && useTrustPilot) {

		let skuArray = [].map.call(productCards, (card) => {
			return card.dataset.sku;
		});

		let allSkusArray = [].map.call(skuArray, (item) => {
			return item.split(',');
		})

		const data = {
			"locale": "en-GB",
			"skus": allSkusArray.flat()
		}
	
		fetch(`https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/batch-summaries?apikey=${apiKey}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		})
		.then(response => {
			return response.json();
		})
		// AMALGAMATE ALL RELATED SKU DATA
		.then(data => {
				return allSkusArray.map(product => {
					
					return product.map(variant => {
						//If the variant has a review summary
						const variantSku = variant;
						const variantSummary = data.summaries.find(item => item.sku == variant)
						return {
							sku: variantSku,
							summary: variantSummary
						}

					});

				}).map(product => {
					const productData = {};
					productData.variants = [];
					productData.reviewCount = 0;
					productData.rating = 0;
					productData.totalRating = 0;

					product.forEach((variant, i) => {
						if (!variant.summary) {
							return
						} 

						productData.variants.push(variant.sku)
						productData.reviewCount = productData.reviewCount + variant.summary.numberOfReviews.total;
						productData.totalRating = productData.totalRating + variant.summary.starsAverage;
						productData.rating = productData.totalRating/productData.variants.length;

						return
					});

					return productData

			});
			
		})
		.then(data => {
			return data.map((item) => {

				return {
					sku: item.variants,
					template: starTemplate(roundToHalf(item.rating).toString().replace('.', '-'), item.reviewCount)
				}
			})
		}).then(items => {

			productCards.forEach(card => {
				
				const el = card.querySelector('.js-card-review');
				const variants = card.dataset.sku.split(',');
				
				const html = items.find(item => {
					return item.sku.some(sku => variants.includes(sku));
				})

				const update = html ? true : false;
				
				if (update) {
					el.innerHTML = html.template;
				}
				el.removeAttribute('hidden');
				
				return 

			})
		});
	}
}